import EntityMember from "_shared/entity-members/entity-member";

export type EntityMemberCommandPayload = {
  userId?: string;
  entityId?: string;
};

export default class EntityMemberCommand {
  public readonly userId?: string;
  public readonly entityId?: string;

  public get payload(): EntityMemberCommandPayload {
    return {
      userId: this.userId,
      entityId: this.entityId,
    };
  }

  public constructor(entityMember: EntityMember) {
    this.userId = entityMember.userId.toJSON();
    this.entityId = entityMember.legalEntityId.toJSON();
  }
}
